import { apiRegistry } from '../../../common/infra/apiRegistry'
import { filesMem } from '../mem/filesMem'

apiRegistry.registerGetApi('getFiles', async (request) => {
  const { parentId = 'root', sortBy = 'name', sortDirection = 'asc' } = request

  // Get files for the specified parent
  const files = Object.values(filesMem).filter(file => file.parentId === parentId)

  // Sort files
  const sortedFiles = files.sort((a, b) => {
    let comparison = 0

    // Always show folders first
    if (a.type === 'folder' && b.type === 'file') return -1
    if (a.type === 'file' && b.type === 'folder') return 1

    switch (sortBy) {
      case 'name':
        comparison = a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        break
      case 'date':
        comparison = new Date(a.modifiedDate).getTime() - new Date(b.modifiedDate).getTime()
        break
      case 'size':
        comparison = (a.size || 0) - (b.size || 0)
        break
      case 'type':
        const aExt = a.extension || ''
        const bExt = b.extension || ''
        comparison = aExt.localeCompare(bExt)
        break
    }

    return sortDirection === 'desc' ? -comparison : comparison
  })

  return { files: sortedFiles }
})